export default class GatewayFee {
  /**
   * Create new gateway fee and set properties based on the given object.
   *
   * @param {Object} obj
   */
  constructor (obj) {
    Object.assign(this, obj)
  }
}
